import React from "react";
import OsmPrototype from "./OsmPrototype";

function MapPage() {

    return (
        <div style={{ width: "100%", height: "98vh" }}>
            <OsmPrototype />
        </div>
    );
}

export default MapPage;